import Vue from 'vue'
import router from 'vue-router'
import VueMeta from 'vue-meta'

Vue.use(router)
Vue.use(VueMeta, {
    keyName: 'page',
})

Vue.router = new router({
    mode: 'history',
    routes: [
        {
            path: '/',
            meta: {
                auth: true,
            },
            component: () => import('../views/Index'),
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    meta: {
                        auth: true,
                        privs: ['has-marketplace', 'has-subscription']
                    },
                    component: () => import('../views/Dashboard/index'),
                },
                {
                    path: '/notifications',
                    name: 'notifications',
                    meta: {
                        auth: true,
                    },
                    component: () => import('../views/Notifications/Index'),
                },
                {
                    path: '/campaigns',
                    meta: {
                        auth: true,
                        privs: ['has-marketplace', 'has-subscription']
                    },
                    component: () => import('../views/Campaigns/Index'),
                    children: [
                        {
                            path: '/campaigns',
                            name: 'campaigns',
                            meta: {
                                auth: true,
                            },
                            component: () => import('../views/Campaigns/Pages/Campaign'),
                        },
                        {
                            path: '/campaigns/templates',
                            name: 'templates',
                            meta: {
                                auth: true,
                            },
                            component: () => import('../views/Templates/Index'),
                        },
                        {
                            path: '/campaigns/queue',
                            name: 'queue',
                            meta: {
                                auth: true,
                            },
                            component: () => import('../views/Campaigns/Pages/Queue'),
                        },
                        {
                            path: '/campaigns/create',
                            name: 'campaigns.create',
                            meta: {
                                auth: true,
                            },
                            component: () => import('../views/Campaigns/Pages/Components/NewCampaign'),
                        },
                        {
                            path: '/campaigns/edit/:campaignId',
                            name: 'campaign.edit',
                            meta: {
                                auth: true,
                            },
                            component: () => import('../views/Campaigns/Pages/Components/EditCampaign'),
                        },
                    ],
                },
                {
                    path: '/catalog',
                    name: 'catalog',
                    meta: {
                        auth: true,
                        privs: ['has-marketplace', 'has-subscription']
                    },
                    component: () => import('../views/Catalog/Index'),
                },
                {
                    path: '/orders',
                    meta: {
                        auth: true,
                        privs: ['has-marketplace', 'has-subscription']
                    },
                    component: () => import('../views/Order/Base'),
                    children: [
                        {
                            path: '/',
                            name: 'order.list',
                            component: () => import('../views/Order/Components/OrderList'),
                        },
                        {
                            path: '/orders/show/:orderId',
                            name: 'order.show',
                            component: () => import('../views/Order/Components/Show'),
                        },
                    ]
                },
                {
                    path: '/reviews',
                    meta: {
                        auth: true,
                        privs: ['has-subscription']
                    },
                    component: () => import('../views/Reviews/Base'),
                    children: [
                        {
                            path: '/reviews',
                            name: 'reviews',
                            component: () => import('../views/Reviews/Index'),
                        },
                        {
                            path: '/reviews/:productId',
                            name: 'reviews.show',
                            component: () => import('../views/Reviews/components/ShowReviews'),
                        }
                    ]
                },
                {
                    path: '/email',
                    meta: {
                        auth: true,
                        privs: ['has-subscription']
                    },
                    component: () => import('../views/Email/Index'),
                    children: [
                        {
                            path: '/email/email-design',
                            name: 'new.template',
                            component: () => import('../views/Email/Components/EmailBuilder'),
                        },
                        {
                            path: '/email/email-design/:emailID',
                            name: 'email.design',
                            component: () => import('../views/Email/Components/EmailBuilder'),
                        },
                    ],
                },
                {
                    path: '/settings',
                    name: 'settings',
                    meta: {
                        auth: true,
                        privs: ['is-verified']
                    },
                    component: () => import('../views/Settings/Index'),
                },
                {
                    path: '/profile',
                    name: 'profile',
                    meta: {
                        auth: true,
                        privs: ['is-verified']
                    },
                    component: () => import('../views/Profile/Index'),
                },
                {
                    path: '/customers',
                    name: 'customers',
                    meta: {
                        auth: true,
                        privs: ['has-marketplace', 'has-subscription']
                    },
                    component: () => import('../views/Customers/Index'),
                },
                {
                    path: '/feedback',
                    name: 'feedback',
                    meta: {
                        auth: true,
                        privs: ['has-marketplace', 'has-subscription']
                    },
                    component: () => import('../views/Feedback/Index'),
                },
                {
                    path: '/smart-tools',
                    meta: {
                        auth: true,
                        privs: ['has-subscription']
                    },
                    component: () => import('../views/SmartTools/Base'),
                    children: [
                        {
                            path: '/smart-tools/magic-product-research',
                            name: 'product.research',
                            component: () => import('../views/SmartTools/ProductResearch/Base'),
                            children: [
                                {
                                    path: '/smart-tools/magic-product-research',
                                    name: 'product.research.index',
                                    component: () => import('../views/SmartTools/ProductResearch/Index'),
                                },
                                {
                                    path: '/smart-tools/magic-product-research/show/:matchId',
                                    name: 'product.research.show',
                                    component: () => import('../views/SmartTools/ProductResearch/Components/Show'),
                                },
                            ]
                        },
                        {
                            path: '/smart-tools/keyword-tool',
                            name: 'keyword_tool',
                            component: () => import('../views/SmartTools/Keyword/Index'),
                        },
                        {
                            path: '/smart-tools/bg-remover',
                            name: 'background_remover',
                            component: () => import('../views/SmartTools/BgRemover/Index'),
                        },
                    ],
                },
                {
                    path: '/no-subscription',
                    name: 'no-subscription',
                    component: () => import('../components/NoSubscriptionComponent'),
                },
                {
                    path: '/no-marketplace',
                    name: 'no-marketplace',
                    component: () => import('../components/NoMarketplaceComponent'),
                },
            ]
        },
        {
            path: '/login',
            component: () => import('./views/account/login'),
            children: [
                {
                    path: '/',
                    name: 'login-form',
                    component: () => import('./views/account/components/LoginForm'),
                },
                {
                    path: '/register',
                    name: 'register-form',
                    component: () => import('./views/account/components/RegisterForm'),
                },
                {
                    path: '/forgot-password',
                    name: 'forgot-password',
                    component: () => import('./views/account/components/ForgotPassword'),
                }
            ],
        },
        {
            path: '/pricing',
            meta: {
                auth: true,
                privs: ['is-verified']
            },
            name: 'pricing',
            component: () => import('../views/Pricing/Index'),
        },
        {
            path: '/reset-password',
            name: 'Reset Password',
            component: () => import('./views/account/components/ResetPassword'),
        },
        {
            path: '/email-verification',
            name: 'email-verification',
            meta: {
                auth: true
            },
            component: () => import('./views/account/email-verification'),
        },
        {
            path: '/email/verify/:userId/:id',
            name: 'confirm-email',
            component: () => import('./views/account/confirm-mail'),
        },
        {
            path: '/forgot-password',
            name: 'Forgot password',
            component: () => import('./views/account/components/ForgotPassword'),
            meta: {
                auth: false
            },
        },
        {
            path: '/logout',
            name: 'logout',
            meta: {
                auth: true,
            },
        },
        {
            path: '/forbidden',
            name: '403',
            mate: {
                auth: false,
            },
            component: () => import('../views/Errors/403'),
        },
        {
            path: '/lwa-redirect',
            name: 'lwa.redirect',
            meta: {
                auth: true,
                privs: ['is-subscription']

            },
            component: () => import('../views/Settings/Components/LwaRedirect'),
        },
        {
            path: '/lwa-callback',
            name: 'lwa.callback',
            meta: {
                auth: true,
                privs: ['is-subscription']
            },
            component: () => import('../views/Settings/Components/LwaCallback'),
        },
        {
            path: '*',
            name: '404',
            mate: {
                auth: false,
            },
            component: () => import('../views/Errors/404'),
        },
    ],

})

const privilegesRedirects = {
    'has-marketplace': 'no-marketplace',
    'has-subscription': 'no-subscription',
    'is-verified': 'email-verification'
}
Vue.router.beforeEach((to, from, next) => {
    if (Vue.auth.check()) {
        const targetHasPrivs = to.meta.privs ? to : to.matched.find((item => item?.meta?.privs && item.meta.privs.length > 0))
        if (targetHasPrivs) {
            targetHasPrivs.meta.privs.map(item => {
                if (!Vue.auth.priv(item)) {
                    next({
                        name: privilegesRedirects[item]
                    })
                }
            })
        }
    }
    next()
})

export default Vue.router
